export default __webpack_public_path__ + "static/media/diamond-color-1@2x.2c38da70.png";